import React from 'react';
import { Modal } from 'antd';
import CompanyDefaultWageForm from './CompanyDefaultWageForm';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function AddCompanyWage() {

    const general = useGeneralStore();
    const visible = general.view.companyDefaultAgent;

    return (
        <Modal
            width={800}
            title="افزودن شرکت جدید"
            visible={visible}
            className="custom-table"
            footer={false}
            onCancel={() => general.ToggleCompanyDefaultAgentModal()}>
            <CompanyDefaultWageForm
                onSubmit={() => {
                    general.ToggleCompanyDefaultAgentModal();
                    general.NotifSuccess('شرکت جدید با موفقیت ثبت شد')
                }}
            />
        </Modal>
    )
}
